export default {
  height:0,
  width:0,
  type:'pc'
}
